import { ADD_EVENT } from '../../actions/constants';
import { sortEvents } from '../../store';

export default { ADD_EVENT: (state, action) => sortEvents(
	state
		.mergeDeep(action.payload)
		.set('id', state.id)
) };
